import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { Equipment, Maintenance } from '@core/interfaces';
import { TranslateService } from '@ngx-translate/core';
import { DialogEditMaintenanceComponent } from '../../../dialog-edit-maintenance/dialog-maintenances.component';

@Component({
  selector: 'app-previous-warranty-dialog',
  templateUrl: './previous-warranty-dialog.component.html',
  styleUrls: ['./previous-warranty-dialog.component.scss'],
})
export class PreviousWarrantyDialogComponent {
  public readonly maintenances: Maintenance[];
  public selectedMaintenance: Maintenance;


  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data,
    public readonly matDialogRef: MatDialogRef<null>,
    private readonly matDialog: MatDialog,
        private readonly maintenancesApi: MaintenancesApi
  ) {
    if (!this.data) { return; }
    this.maintenances = this.data;
  }

  public continue(): void {
    if (!this.maintenances) {
      this.matDialogRef.close();
      return;
    }

    const selectedMaintenanceId = this.selectedMaintenance ? this.selectedMaintenance.id : null;
    this.matDialogRef.close({ selectedMaintenanceId });
  }

  public async openPreviousMaintenance(selectedMaintenance: Maintenance): Promise<void> {
    const maintenance = await this.maintenancesApi.searchOne(selectedMaintenance.id).toPromise();

    this.matDialog.open(DialogEditMaintenanceComponent, {
      panelClass: 'dialog-edit-maintenance',
      data: {
        maintenance,
        isViewMode: false,
        selectedTabIndex: 0,
      }
    });
  }
}
